var UtilityConfig = {
    remBase: 16
  },
  splitUnits = function splitUnits(t) {
    return {
      number: parseFloat(t),
      units: String(t).replace(/^[\d.-]+/, "")
    };
  },
  calculateRem = function calculateRem() {
    for (var t = "", e = 0; e < arguments.length; ++e) {
      var r = e < 0 || arguments.length <= e ? void 0 : arguments[e];
      "" !== t && (t += " ");
      var n = splitUnits(r);
      "rem" !== n.units ? t += n.number / UtilityConfig.remBase : t += n.number, 0 != n.number && (t += "rem");
    }
    return t;
  };
export { calculateRem, UtilityConfig };